import { defineStore } from 'pinia';
import { isFeatureEnabled } from '~/modules/feature-toggle-router';

type ISettingStore = {
  isMobileDevice: boolean;
  meta: Record<string, any>;
  isAddinMode: boolean;
  maxNumberOfPartsInCart: number;
  websiteName: string;
  currentRoute: {
    fullPath: string;
  };
  storeMode: boolean;
  exactExtensions: string[];
  checkAndRepairExtensions: string[];
  dfmExtensions: string[];
};

export const useSettingsStore = defineStore({
  id: 'settings',
  state: (): ISettingStore => ({
    isMobileDevice: false,
    storeMode:
      typeof window !== 'undefined' ? sessionStorage.getItem('storeMode') === 'true' : false,
    meta: {},
    isAddinMode: false,
    maxNumberOfPartsInCart: 15,
    websiteName: 'Make',
    currentRoute: {
      fullPath: '',
    },
    exactExtensions: ['catpart', 'sldprt', 'step', 'stp'],
    checkAndRepairExtensions: [
      'smallFaces',
      'smallEdges',
      'singularEdges',
      'degeneratedTriangles',
      'duplicatedTriangles',
      'boundaries',
      'separatedZones',
      'isOriented',
    ],
    dfmExtensions: ['stl', 'obj', 'stp', 'step', '3dxml', 'catpart', 'sldprt', 'igs', 'iges'],
  }),
  getters: {
    pathologiesToRead(state): (format: string) => string[] {
      return (format: string) => {
        if (
          state.exactExtensions.includes((format || '').toLowerCase()) &&
          isFeatureEnabled('CARExt')
        ) {
          return ['smallFaces', 'smallEdges', 'boundaries'];
        }

        return [
          'singularEdges',
          'degeneratedTriangles',
          'duplicatedTriangles',
          'boundaries',
          'separatedZones',
          'isOriented',
        ];
      };
    },
    isIOSDevice() {
      return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
          navigator.platform,
        ) ||
        // IPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      );
    },
    isSafariBrowser() {
      const ua = window.navigator.userAgent;
      const iOS = /Macintosh/i.exec(ua) || /iPad/i.exec(ua) || /iPhone/i.exec(ua);
      const webkit = /WebKit/i.exec(ua);
      return (
        iOS &&
        webkit &&
        !/CriOS/i.exec(ua) &&
        !/EdgiOS/i.exec(ua) &&
        !/Chrome/i.exec(ua) &&
        !/Edg/i.exec(ua)
      );
    },
  },
  actions: {
    setCurrentRoute(route: any) {
      this.currentRoute = route;
    },
    setIsMobileDevice(value: boolean) {
      this.isMobileDevice = value;
    },
    setIsAddinMode(value: boolean) {
      this.isAddinMode = value;
    },
    getDriveEnabledExtensions() {
      return [
        'stl',
        'obj',
        'stp',
        'step',
        '3dxml',
        'catpart',
        'sldprt',
        'igs',
        'iges',
        'dxf',
        'dwg',
      ];
    },
    // META
    setMetaOfPage(meta: string, value: string) {
      this.meta[meta] = value;
    },
    resetMeta() {
      this.meta = {};
    },
    setStoreMode(storeMode: boolean) {
      this.storeMode = storeMode;
      sessionStorage.setItem('storeMode', this.storeMode.toString());
    },
  },
});
